import { call, put, takeLatest } from 'redux-saga/effects';

import { captureException } from '../../../../client/sentry';
import { graphql } from '../../../../globals/api/requests';

import { onEditReview, onRemoveReview } from '../actions';

import { UPDATE_REVIEW_DATA } from '../../../reviews/actions';

type UpdateMyReviewsArgs = {
  type: typeof UPDATE_REVIEW_DATA;
  id: string;
  actionType: 'CREATE' | 'EDIT' | 'DELETE';
};

function* updateMyReviews({ id, actionType }: UpdateMyReviewsArgs) {
  switch (actionType) {
    case 'CREATE':
      break;
    case 'EDIT': {
      try {
        const query = `
          query updatedUserReview($id: Int!) {
            userReview(id: $id) {
                id
                text
                rating
                score
                views
                createdAt
                updatedAt
                product {
                  id
                  name
                  pathName
                  priceSummary {
                    regular
                  }
                  userReviewSummary {
                    rating
                    count
                  }
                  media {
                    first(width: _140)
                  }
                }
              }
            }
        `;

        const response = yield call(graphql, query, { id });

        if (response.errors) {
          yield call(captureException, response.errors);
          return;
        }

        yield put(onEditReview(response.data.userReview));
      } catch (e) {
        yield call(captureException, e);
      }
      break;
    }
    case 'DELETE':
      yield put(onRemoveReview(id));
      break;
    default:
  }
}

function* mySaga() {
  yield takeLatest(UPDATE_REVIEW_DATA, updateMyReviews);
}

export default mySaga;
